/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import axios from "axios";
import _ from "lodash"
import {ASYNC_KEY} from "./util/General"
import { logout } from "../core/auth/authentication";

const headers = {
    'Access-Control-Allow-Origin': "*",
    'Access-Control-Allow-Credentials': 'true',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

export const GetRequest = (url, data, params) => {
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
      const response = axios({
          method: 'get',
          url: `${url}`,
          headers: headers,
          params,
          data: data
      });
      return response.then(data=>{
        return response
      }).catch(
        function (error) {
          console.log('Show error notification!', error.message)
          if(error.message == 'Request failed with status code 401') {
            logout()
            window.location.reload();
          }
          return Promise.reject(error)
        }
      )      
      return response;
  } catch (error) {      
      console.log('>axios error:', error);
  }
};  

export const PostRequest = (url, data, params) => {
    headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
    try {
        const response = axios({
            method: 'post',
            url: `${url}`,
            headers: headers,
            params,
            data: data
        });
        return response.then(data=>{
          return response
        }).catch(
          function (error) {
            console.log('Show error notification!', error.message)
            if(error.message == 'Request failed with status code 401') {
              logout()
              window.location.reload();
            }
            return Promise.reject(error)
          }
        )      
        return response;
    } catch (error) {      
        console.log('>axios error:', error);
    }
};  

export const GetResultObject = (result, key, code = 200, success, error) => {

  console.log(">> result", result)

  if(_.get(result, 'data.code') == code) {
    success && success(
      _.get(result, `data.${key}`)
      ,
      {
        pages:_.get(result, 'data.data.totalPages')
        , size: _.get(result, 'data.data.numberOfElements')
        , total: _.get(result, 'data.data.totalElements')
      }
    )
  } else{
    console.log('>Error', _.get(result, 'data.code'))
    error && error("Action failed")
  }
}
  